import { TextField } from '@mui/material';
import { useEffect } from 'react';
import useForm from '../hooks/useForm';
import { useLanguage } from '../contexts/language';
import getMaterialInputsFormHelper from '../utils/getMaterialInputsFormHelper';
import ConfirmationDialog from './ConfirmationDialog';

const RequiredNoteConfirmationDialog = ({
  title,
  noteLabel,
  open,
  loading,
  disabled,
  onCloseRequest,
  onConfirmRequest,
}: {
  title: string;
  noteLabel: string;
  open: boolean;
  loading: boolean;
  disabled: boolean;
  onCloseRequest: () => void;
  onConfirmRequest: (note: string) => void;
}) => {
  const { t } = useLanguage();

  const formState = useForm({
    initialValues: { note: '' },
    onSubmit: ({ note }) => {
      if (open) {
        onConfirmRequest(note);
      }
    },
    validate: ({ note }, setError) => {
      if (!note.trim()) {
        setError('note', t('validation.required-field'));
      }
    },
  });

  const { getTextFieldProps } = getMaterialInputsFormHelper(formState);

  const handleClose = () => {
    onCloseRequest();
    formState.reset();
  };

  useEffect(() => {
    if (!open) {
      formState.reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <ConfirmationDialog
      open={open}
      onClose={handleClose}
      loading={loading}
      title={title}
      onConfirm={formState.handleSubmit}
      submitDisabled={formState.hasVisibleErrors || disabled}
    >
      <p className="mb-4 text-gray-500">{noteLabel}</p>
      <TextField
        {...getTextFieldProps('note', true)}
        placeholder={`${t('content.start-typing-here')}...`}
        multiline
        rows={5}
      />
    </ConfirmationDialog>
  );
};

export default RequiredNoteConfirmationDialog;
